export default function SaveArtworkIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={`save-artwork-icon ${className}`}
      onClick={onClick}
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M372.17,419.46l-121.7-117.47-122.67,117.5c-7.63,7.31-20.3,1.9-20.3-8.67V89.15c0-6.63,5.37-12,12-12h261c6.63,0,12,5.37,12,12v321.68c0,10.59-12.72,15.99-20.33,8.63ZM132.5,102.15v278.22l118.03-113.06,116.97,112.9V102.15h-235Z"
      />
    </svg>
  );
}
